import { useAppSelector } from 'shared';

// eslint-disable-next-line import/prefer-default-export
export const useHomePageState = () => useAppSelector((store) => store.homePage);
